import { Moment } from 'moment';
import { apiGet, API_URI } from './index';

const dailyInsights = {
    getAll: async (projectId: number, startDate: Moment, endDate: Moment, streamIds: number[]) => {
        const data = await apiGet(`${API_URI}/api/dailyinsights/getall?projectId=${projectId}&startDate=${startDate.format("DD MMM YYYY HH:mm:ss")}&endDate=${endDate.format("DD MMM YYYY HH:mm:ss")}&streamIds=${streamIds.join(',')}`)
        return data;
    }
}

export default dailyInsights;